import Drip from 'drip';
export default {
  data: function data() {
    return {
      topPositionExtra: 42,
      // 定位用到的额外值，否则部分内容会被遮挡
      anchorStatus: [],
      // 记录锚点的ui展示状态
      anchorOpacity: 0,
      // 锚点栏透明度
      showAnchor: false,
      // 是否展示锚点栏
      // isShowLight: false, // 是否展示亮点
      isShowDetail: false,
      // 是否展示详情
      isSHowNotice: false,
      // 是否展示须知
      isShowRecommand: false,
      // 是否展示推荐列表
      selectedAnchor: '' // 选中锚点
    };
  },

  methods: {
    // 计算是否展示亮点锚点
    getIsShowDetail: function getIsShowDetail(performanceInfo) {
      var _performanceInfo$brig = performanceInfo.brightPointList,
        brightPointList = _performanceInfo$brig === void 0 ? [] : _performanceInfo$brig,
        _performanceInfo$vide = performanceInfo.videoList,
        videoList = _performanceInfo$vide === void 0 ? [] : _performanceInfo$vide,
        _performanceInfo$phot = performanceInfo.photoStageList,
        photoStageList = _performanceInfo$phot === void 0 ? [] : _performanceInfo$phot,
        detail = performanceInfo.detail;
      return brightPointList && brightPointList.length > 0 || videoList && videoList.length > 0 || (photoStageList && photoStageList.length) > 0 || !!detail;
    },
    getIsShowNotice: function getIsShowNotice(performanceInfo) {
      return !!performanceInfo.ticketNotes;
    },
    // 计算是否展示推荐锚点
    getIsShowRecommand: function getIsShowRecommand(recommandList) {
      //商家自销（非主办自销）已下架，为保险先注释，没问题后可删
      // const salesWay = Drip.constant.search.salesWay
      return recommandList && recommandList.length > 0; //!salesWay && 
    },

    // 锚点状态
    getAnchorStatus: function getAnchorStatus(isShowDetail, isShowNotice, isShowRecommand, isShowComment) {
      var anchors = [];
      if (isShowDetail) {
        anchors.push({
          text: '演出介绍',
          id: 'detail'
        });
      }
      if (isShowComment) {
        anchors.push({
          text: '评价',
          id: 'comment'
        });
      }
      if (isShowNotice) {
        anchors.push({
          text: '购票须知',
          id: 'notice'
        });
      }
      if (isShowRecommand) {
        anchors.push({
          text: '推荐',
          id: 'recommand'
        });
      }
      return anchors;
    },
    getIsShowAnchor: function getIsShowAnchor(anchorStatus) {
      return anchorStatus.length > 1;
    },
    // 点击锚点
    onAnchorClick: function onAnchorClick(selectedId) {
      var anchorOpacity = this.anchorOpacity,
        showAnchor = this.showAnchor;
      // 透明度为0时不响应
      if (anchorOpacity === 0 || !showAnchor) return;
      this.changeAnchor(selectedId); // 更改选中锚点
      this.scrollToViewFn(selectedId); // 移动到锚点位置
    },

    // 更改锚点
    changeAnchor: function changeAnchor(selectedId) {
      var selectedAnchor = this.selectedAnchor;
      if (selectedAnchor !== selectedId) {
        this.selectedAnchor = selectedId;
      }
    },
    scrollToViewFn: function scrollToViewFn(selectedId) {
      var selectedAnchor = document.getElementById(selectedId);
      if (!selectedAnchor) {
        return;
      }
      var total = selectedAnchor.offsetTop;
      total = total - this.topPositionExtra;
      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
    },
    // 滑动时，响应式更改锚点的被选中显示
    setSelectedAnchorByScrollTop: function setSelectedAnchorByScrollTop(scrollTop) {
      var topPositionExtra = this.topPositionExtra,
        showAnchor = this.showAnchor,
        isShowNotice = this.isShowNotice,
        isShowDetail = this.isShowDetail,
        isShowRecommand = this.isShowRecommand,
        anchorStatus = this.anchorStatus,
        isShowComment = this.isShowComment;
      if (!showAnchor) return;
      if (isShowNotice) {
        var _selectedAnchor = document.getElementById('notice');
        var _top = _selectedAnchor.offsetTop;
        var bottom = _selectedAnchor.offsetTop + _selectedAnchor.offsetHeight;
        if (scrollTop >= _top - topPositionExtra && scrollTop <= bottom - topPositionExtra) {
          this.changeAnchor('notice');
        }
      }
      if (isShowDetail) {
        var _selectedAnchor2 = document.getElementById('detail');
        var _top2 = _selectedAnchor2.offsetTop;
        var _bottom = _selectedAnchor2.offsetTop + _selectedAnchor2.offsetHeight;
        if (scrollTop >= _top2 - topPositionExtra && scrollTop <= _bottom - topPositionExtra) {
          this.changeAnchor('detail');
        }
      }
      if (isShowRecommand) {
        var _selectedAnchor3 = document.getElementById('recommand');
        var _top3 = _selectedAnchor3.offsetTop;
        var _bottom2 = _selectedAnchor3.offsetTop + _selectedAnchor3.offsetHeight;
        if (scrollTop >= _top3 - topPositionExtra && scrollTop <= _bottom2 - topPositionExtra) {
          this.changeAnchor('recommand');
        }
      }
      if (isShowComment) {
        var _selectedAnchor4 = document.getElementById('comment');
        var _top4 = _selectedAnchor4.offsetTop;
        var _bottom3 = _selectedAnchor4.offsetTop + _selectedAnchor4.offsetHeight;
        if (scrollTop >= _top4 - topPositionExtra && scrollTop <= _bottom3 - topPositionExtra) {
          this.changeAnchor('comment');
        }
      }
      var firstAnchorId = anchorStatus[0].id;
      var selectedAnchor = document.getElementById(firstAnchorId);
      var top = selectedAnchor.offsetTop;
      if (scrollTop < top - topPositionExtra) {
        this.changeAnchor(firstAnchorId);
      }
    },
    // 设置锚点透明度
    toggleAnchorByScrollTop: function toggleAnchorByScrollTop(scrollTop) {
      var showAnchor = this.showAnchor;
      if (!showAnchor) return;
      var top = 300; // 锚点透明度距离页面顶高度设置透明度依据
      var anchorOpacity;
      if (scrollTop < top) {
        anchorOpacity = scrollTop / top;
        if (this.anchorOpacity === 1) {
          this.hideAnchorAnimate();
        }
      } else {
        anchorOpacity = 1;
        if (this.anchorOpacity !== 1) {
          this.showAnchorAnimate();
        }
      }
      this.anchorOpacity = anchorOpacity;
    },
    showAnchorAnimate: function showAnchorAnimate() {
      var anchorElement = document.getElementById('anchor-component');
      if (anchorElement) {
        anchorElement.animate([{
          top: '-120px',
          opacity: 0
        }, {
          top: '0',
          opacity: 1
        }], {
          fill: 'forwards',
          duration: 200
        });
      }
    },
    hideAnchorAnimate: function hideAnchorAnimate() {
      var anchorElement = document.getElementById('anchor-component');
      if (anchorElement) {
        anchorElement.animate([{
          top: '0',
          opacity: 1
        }, {
          top: '-120px',
          opacity: 0
        }], {
          fill: 'forwards',
          duration: 200
        });
      }
    },
    LoadAnchor: function LoadAnchor() {
      this.isShowDetail = this.getIsShowDetail(this.performanceInfo);
      this.isShowNotice = this.getIsShowNotice(this.performanceInfo);
      this.isShowRecommand = this.getIsShowRecommand(this.recommandList);
      var anchorStatus = this.getAnchorStatus(this.isShowDetail, this.isShowNotice, this.isShowRecommand, this.isShowComment);
      this.anchorStatus = anchorStatus;
      // 计算是否展示锚点栏
      var showAnchor = this.getIsShowAnchor(anchorStatus);
      this.showAnchor = showAnchor;
      // 默认选中第一个
      var selectedAnchor = anchorStatus[0].id;
      this.selectedAnchor = selectedAnchor;
    }
  },
  computed: {
    isShowComment: function isShowComment() {
      // 是否展示评论
      var _this$commentInfo = this.commentInfo,
        userComments = _this$commentInfo.userComments,
        queryComments = _this$commentInfo.queryComments,
        scoreStatus = _this$commentInfo.scoreStatus;
      return scoreStatus && (userComments && userComments.commentList || queryComments && queryComments.commentList);
    }
  }
};